import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import { LuAlertCircle, LuCheck, LuX } from "react-icons/lu";
import {
  createPODs,
  deletePODs,
  getPODs,
  updatePODConfig,
  updatePODs,
} from "../../actions";
import MessageBlock from "../common/MessageBlock";
import { Dropdown, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { FiCheck, FiEdit2, FiInfo, FiTrash, FiX } from "react-icons/fi";
import { PERMANENT_POD_RETENTION } from "../../../constants/types";

const POD_RETENTION_POLICY = {
  "1d": "1 Day",
  "7d": "7 Days",
  "30d": "30 Days",
  [PERMANENT_POD_RETENTION]: "Never",
};

const PODTemplateItem = ({ pod, id, onEdit, onDelete, toggleRequired }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  return (
    <div className={"pod-list-item"} key={id}>
      <div
        className={"d-flex flex-row align-items-start justify-content-between"}
      >
        <div className={"d-flex flex-column gap-3"}>
          <p>{pod.name}</p>
          <p className={"info"}>{pod.description}</p>
        </div>
        <div className={"d-flex flex-row align-items-center"}>
          <label className={"form-checkbox "} onClick={toggleRequired}>
            <div className={`check ${pod.is_required ? "active" : ""}`}>
              <LuCheck color={"white"} />
            </div>
            <p>
              Always required
              <OverlayTrigger
                key={"pod-tooltip"}
                placement="auto"
                overlay={
                  <Tooltip id="pod-tooltip" className={"checkout-address-info"}>
                    {"Require this item by default for all labels."}
                  </Tooltip>
                }
                delayShow={300}
                delayHide={150}
              >
                <span className={"pod-tooltip"}>
                  <FiInfo className={"warning"} />
                </span>
              </OverlayTrigger>
            </p>
          </label>
          {showConfirmation ? (
            <div>
              <p>Are you sure?</p>
              <div className={"d-flex flex-row"}>
                <button onClick={() => setShowConfirmation(false)}>
                  <FiX color={"red"} />
                </button>
                <button
                  onClick={() => {
                    onDelete();
                    setShowConfirmation(false);
                  }}
                >
                  <FiCheck />
                </button>
              </div>
            </div>
          ) : (
            <>
              <button onClick={onEdit}>
                <FiEdit2 />
              </button>
              <button onClick={() => setShowConfirmation(true)}>
                <FiTrash color={"red"} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const ProofOfDeliveryConfig = (props) => {
  const { getPODs } = props;
  const [formPOD, setFormPOD] = useState({
    name: "",
    description: "",
    is_required: false,
  });
  const [showForm, setShowForm] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getPODs();
  }, [getPODs]);

  const handleSubmit = () => {
    let valid = true;
    const newErrors = {};
    if (!formPOD.name.trim()) {
      newErrors.name = "This field is required";
      valid = false;
    }
    if (!formPOD.description.trim()) {
      newErrors.description = "This field is required";
      valid = false;
    }
    if (!valid) {
      setErrors(newErrors);
      return;
    }
    if (!!formPOD.id) {
      const { id, ...pod } = formPOD;
      props.updatePODs(id, pod, () => {
        props.getPODs();
        setShowForm(false);
        setFormPOD({
          name: "",
          description: "",
          is_required: false,
        });
      });
    } else {
      props.createPODs(formPOD, () => {
        props.getPODs();
        setShowForm(false);
        setFormPOD({
          name: "",
          description: "",
          is_required: false,
        });
      });
    }
  };

  return (
    <div className="modal d-flex">
      <div
        className="backdrop"
        onClick={() => {
          props.close();
        }}
      ></div>
      <div className={`modal-content pod-config settings-card `}>
        <div
          className={
            "card-section head d-flex flex-row justify-content-between align-items-center"
          }
        >
          <h3>Proof of Delivery</h3>
          <a onClick={props.close}>
            <LuX />
          </a>
        </div>
        {showForm ? (
          <div className={"card-section "}>
            {props.error ? (
              <MessageBlock
                type={"error"}
                message={props.error}
                icon={<LuAlertCircle />}
              />
            ) : null}
            <label
              className={`d-flex flex-column flex-grow-1 mb-3 ${errors?.name ? "show-error" : ""}`}
            >
              <p className={"package-prompt"}>
                Name<span className={"text-danger"}>*</span>
              </p>
              <input
                value={formPOD.name}
                required
                onChange={(e) => {
                  const { name, ...rest } = errors;
                  setErrors(rest);
                  setFormPOD({
                    ...formPOD,
                    name: e.target.value,
                  });
                }}
              />
              {errors?.name ? (
                <p className={"text-danger"}>This field is required</p>
              ) : null}
            </label>
            <label
              className={`d-flex flex-column flex-grow-1 mb-3 ${errors?.description ? "show-error" : ""}`}
            >
              <p className={"package-prompt"}>
                Description<span className={"text-danger"}>*</span>
              </p>
              <input
                value={formPOD.description}
                required
                onChange={(e) => {
                  const { description, ...rest } = errors;
                  setErrors(rest);
                  setFormPOD({
                    ...formPOD,
                    description: e.target.value,
                  });
                }}
              />
              {errors?.description ? (
                <p className={"text-danger"}>This field is required</p>
              ) : null}
            </label>
            <label
              className={"form-checkbox "}
              onClick={() =>
                setFormPOD({
                  ...formPOD,
                  is_required: !formPOD.is_required,
                })
              }
            >
              <div
                className={`check mr-2 ${formPOD.is_required ? "active" : ""}`}
              >
                <LuCheck color={"white"} />
              </div>
              <p>Always required</p>
              <OverlayTrigger
                key={"pod-tooltip"}
                placement="auto"
                overlay={
                  <Tooltip id="pod-tooltip" className={"checkout-address-info"}>
                    {"Require this item by default for all labels."}
                  </Tooltip>
                }
                delayShow={300}
                delayHide={150}
              >
                <span className={"pod-tooltip"}>
                  <FiInfo className={"warning mx-2 "} />
                </span>
              </OverlayTrigger>
            </label>
          </div>
        ) : (
          <div className={"card-section "}>
            <h4 className={"info"}>Proof of Delivery Items</h4>
            <MessageBlock
              icon={<FiInfo />}
              message={
                "Required items the driver must capture from the customer on delivery"
              }
            />
            {props.pods.map(({ id, ...pod }) => {
              return (
                <PODTemplateItem
                  pod={pod}
                  id={id}
                  onEdit={() => {
                    setFormPOD({ id, ...pod });
                    setShowForm(true);
                  }}
                  toggleRequired={() =>
                    props.updatePODs(
                      id,
                      {
                        ...pod,
                        is_required: !pod.is_required,
                      },
                      props.getPODs,
                    )
                  }
                  onDelete={() => {
                    props.deletePODs(id, props.getPODs);
                  }}
                />
              );
            })}
            <button className={"add-pod"} onClick={() => setShowForm(true)}>
              {" "}
              + Add requirement
            </button>
            <div className={"divider"}></div>

            <h4 className={"info"}>Additional Settings</h4>
            <MessageBlock
              icon={<FiInfo />}
              message={
                "This configures account level settings that applies to all label creation"
              }
            />
            {props.error ? (
              <MessageBlock
                type={"error"}
                message={props.error}
                icon={<LuAlertCircle />}
              />
            ) : null}
            <label
              className={"form-checkbox "}
              onClick={() =>
                props.updatePODConfig(
                  {
                    require_signature: !props.requireSignature,
                  },
                  props.getPODs,
                )
              }
            >
              <div
                className={`check mr-2 ${props.requireSignature ? "active" : ""}`}
              >
                <LuCheck color={"white"} />
              </div>
              <p>Requires signature by default</p>
              <OverlayTrigger
                key={"pod-tooltip"}
                placement="auto"
                overlay={
                  <Tooltip id="pod-tooltip" className={"checkout-address-info"}>
                    {
                      "When Proof of Delivery is enabled, a signature will also be required by default."
                    }
                  </Tooltip>
                }
                delayShow={300}
                delayHide={150}
              >
                <span className={"pod-tooltip"}>
                  <FiInfo className={"warning mx-2"} />
                </span>
              </OverlayTrigger>
            </label>
            <label
              className={"form-checkbox "}
              onClick={() =>
                props.updatePODConfig(
                  {
                    require_pod_approval: !props.requireApproval,
                  },
                  props.getPODs,
                )
              }
            >
              <div
                className={`check mr-2 ${props.requireApproval ? "active" : ""}`}
              >
                <LuCheck color={"white"} />
              </div>
              <p>Requires approval</p>
              <OverlayTrigger
                key={"pod-tooltip"}
                placement="auto"
                overlay={
                  <Tooltip id="pod-tooltip" className={"checkout-address-info"}>
                    {
                      "The delivery must be approved before the driver can mark it as complete."
                    }
                  </Tooltip>
                }
                delayShow={300}
                delayHide={150}
              >
                <span className={"pod-tooltip"}>
                  <FiInfo className={"warning mx-2"} />
                </span>
              </OverlayTrigger>
            </label>

            <label
              className={"form-checkbox "}
              onClick={() =>
                props.updatePODConfig(
                  {
                    allow_extra_pods: !props.allowExtras,
                  },
                  props.getPODs,
                )
              }
            >
              <div
                className={`check mr-2 ${props.allowExtras ? "active" : ""}`}
              >
                <LuCheck color={"white"} />
              </div>
              <p>Allow extras</p>
              <OverlayTrigger
                key={"pod-tooltip"}
                placement="auto"
                overlay={
                  <Tooltip id="pod-tooltip" className={"checkout-address-info"}>
                    {"Enables drivers to capture up to 3 extra proof of delivery images. " +
                      "These additional images are optional and won't prevent delivery from being completed."}
                  </Tooltip>
                }
                delayShow={300}
                delayHide={150}
              >
                <span className={"pod-tooltip"}>
                  <FiInfo className={"warning mx-2"} />
                </span>
              </OverlayTrigger>
            </label>
            <label className={"auto-delete my-3 w-100"}>
              <div className={"d-flex flex-row align-items-center mb-3"}>
                <h4>Auto delete proof of delivery content after</h4>
                <OverlayTrigger
                  key={"pod-tooltip"}
                  placement="auto"
                  overlay={
                    <Tooltip
                      id="pod-tooltip"
                      className={"checkout-address-info"}
                    >
                      {"Defines when uploaded proof of delivery images are automatically deleted. " +
                        "By default, images are never deleted unless a specific period is selected."}
                    </Tooltip>
                  }
                  delayShow={300}
                  delayHide={150}
                >
                  <span className={"pod-tooltip"}>
                    <FiInfo className={"warning"} />
                  </span>
                </OverlayTrigger>
              </div>
              <Dropdown>
                <Dropdown.Toggle className="auto-delete-dropdown col-12 p-0 px-3 d-flex flex-row justify-content-between align-items-center">
                  {POD_RETENTION_POLICY[props.retentionPolicy]}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {Object.keys(POD_RETENTION_POLICY).map((value) => (
                    <Dropdown.Item
                      key={value}
                      onClick={() => {
                        props.updatePODConfig(
                          {
                            pod_retention_policy: value,
                          },
                          props.getPODs,
                        );
                      }}
                    >
                      {POD_RETENTION_POLICY[value]}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </label>
            {props.loading ? (
              <div className={"loading-overlay"}>
                <Spinner animation={"border"} />
              </div>
            ) : null}
          </div>
        )}
        {showForm ? (
          <div
            className={
              "card-section last d-flex flex-column flex-lg-row justify-content-end align-items-center gap-3"
            }
          >
            <button
              className={"button-secondary"}
              onClick={() => {
                setShowForm(false);
                props.getPODs();
              }}
            >
              Cancel
            </button>
            <button onClick={handleSubmit} disabled={props.loading}>
              {props.loading ? (
                <Spinner animation={"border"} />
              ) : !!formPOD.id ? (
                "Update"
              ) : (
                "Add"
              )}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = ({ pod }) => ({
  loading: pod.loading,
  error: pod.error,
  pods: pod.pods,
  requireSignature: pod.require_signature,
  requireApproval: pod.require_pod_approval,
  retentionPolicy: pod.pod_retention_policy,
  allowExtras: pod.allow_extra_pods,
});

export default connect(mapStateToProps, {
  getPODs,
  createPODs,
  updatePODs,
  updatePODConfig,
  deletePODs,
})(ProofOfDeliveryConfig);
